import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, BookOpen, Map, Clock, BarChart3, Library, Settings, Plus,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useToast } from '@/hooks/use-toast';

const NAV_ITEMS = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/items', icon: BookOpen, label: 'Items' },
  { to: '/scenes', icon: Map, label: 'Scenes' },
  { to: '/logs', icon: Clock, label: 'Logs' },
  { to: '/stats', icon: BarChart3, label: 'Stats' },
  { to: '/books', icon: Library, label: 'Books' },
];

export function Sidebar() {
  const { toast } = useToast();
  return (
    <aside className="fixed left-0 top-0 h-screen w-60 bg-[#f8fafc] border-r border-slate-200/60 flex flex-col z-50">
      {/* Logo */}
      <div className="px-4 pt-5 pb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#4648d4] rounded-lg flex items-center justify-center shadow-md">
            <span className="text-white text-sm font-bold">C</span>
          </div>
          <div>
            <div className="text-slate-900 font-semibold text-xl tracking-tight">Cadence</div>
            <div className="text-slate-500 text-[10px] tracking-[1px] uppercase font-medium">English Learning OS</div>
          </div>
        </div>
      </div>

      {/* New Session Button */}
      <div className="px-4 pb-6">
        <button
          onClick={() => {
            navigator.clipboard.writeText('/cadence train');
            toast({ title: 'Command Copied', description: 'Paste /cadence train in your AI chat to start a new session.' });
          }}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-white text-sm font-semibold shadow-md hover:shadow-lg transition-all active:scale-[0.98]"
          style={{ backgroundImage: 'linear-gradient(168deg, #4648d4 0%, #6063ee 100%)' }}
        >
          <Plus className="w-4 h-4" />
          New Session
        </button>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 px-3 space-y-1">
        {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-4 py-2 rounded-lg text-sm transition-all',
                isActive
                  ? 'bg-white text-indigo-600 font-semibold shadow-sm'
                  : 'text-slate-500 font-medium hover:bg-white/60 hover:text-slate-700',
              )
            }
          >
            <Icon className="w-[18px] h-[18px]" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div className="px-3 pb-4 space-y-1 border-t border-slate-200/50 pt-4">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            cn(
              'flex items-center gap-3 px-4 py-2 rounded-lg text-sm transition-all',
              isActive ? 'bg-white text-indigo-600 font-semibold shadow-sm' : 'text-slate-500 font-medium hover:bg-white/60',
            )
          }
        >
          <Settings className="w-[18px] h-[18px]" />
          Settings
        </NavLink>
      </div>
    </aside>
  );
}
